import {
  getRequest,
  postRequest,
  patchRequest,
  uploadEncodedFile,
} from "NetworkCall";
import {
  INSTANCE_URL,
  BASE_IMAGES_URL,
  BASE_IMAGES_LOCAL_URL,
} from "Constants";
import { isEmpty } from "ActionsSpeakers";
import _ from "lodash";
import { randomstring } from "randomstring-js";

export var MANAGECHALLENGES_SINGLE = "MANAGECHALLENGES_SINGLE";
export var MANAGECHALLENGES_RECURRING = "MANAGECHALLENGES_RECURRING";
export var MANAGECHALLENGES_TAB_SELECTED = "MANAGECHALLENGES_TAB_SELECTED";
export var MANAGECHALLENGES_SINGE_LIST = "MANAGECHALLENGES_SINGE_LIST";
export var MANAGECHALLENGES_RECURRING_LIST = "MANAGECHALLENGES_RECURRING_LIST";
export var LOAD_EDIT_CHALLENGES_DATA = "LOAD_EDIT_CHALLENGES_DATA";
export var OPEN_CHALLENGES_MODAL = "OPEN_CHALLENGES_MODAL";
export var MANAGECHALLENGES_MAX_DISPLAYORDER =
  "MANAGECHALLENGES_MAX_DISPLAYORDER";
export var MANAGECHALLENGES_HTML_TEMPLATE = "MANAGECHALLENGES_HTML_TEMPLATE";

// Get max DISPLAYORDER number
export function getMaxDisplayorder(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/gamification_admin_script`;

  return (dispatch) => {
    postRequest(
      url,
      {
        requesttype: "getmaxdisplayorder",
        eventid: session.eventid,
      },
      session,
      dispatch,
      (response) => {
        dispatch({
          type: MANAGECHALLENGES_MAX_DISPLAYORDER,
          payload: { data: response.resource.data },
        });
        callback({ status: 1 });
      },
      (error) => {}
    );
  };
}

// Tab on select
export function onManagechallengesSelectedTab(selectedMenu) {
  return (dispatch) => {
    dispatch({ type: MANAGECHALLENGES_TAB_SELECTED, payload: selectedMenu });
  };
}

// recurring / single
export function fetchManageChallengesList(
  session,
  searchkey = "",
  callfor,
  callback
) {
  var url = `${INSTANCE_URL}/api/v2/gamification_admin_script`;

  return (dispatch) => {
    postRequest(
      url,
      {
        requesttype: "fetchchallengeslist",
        eventid: session.eventid,
        searchkey: searchkey,
        callfor: callfor,
      },
      session,
      dispatch,
      (response) => {
        //  if(response.resource.data){
        //   // Data available
        //    alert(1);
        //  }else{
        //   // Data available
        //  }
        if (callfor == "single") {
          dispatch({
            type: MANAGECHALLENGES_SINGE_LIST,
            payload: {
              data: response.resource.data ? response.resource.data : {},
              count: response.resource.data ? response.resource.data.length : 0,
            },
          });
        } else {
          dispatch({
            type: MANAGECHALLENGES_RECURRING_LIST,
            payload: {
              data: response.resource.data ? response.resource.data : {},
              count: response.resource.data ? response.resource.data.length : 0,
            },
          });
        }

        callback({ status: 1 });
      },
      (error) => {}
    );
  };
}

// Update Toggle [Activate / Deactivate]

export function toggleActivateDeactivateChallenge(
  session,
  id,
  isactive,
  callback
) {
  //var url = `${INSTANCE_URL}/api/v2/gamification_admin_script`;

  let url = `${INSTANCE_URL}/api/v2/eventify/_table/gamification_challenge/${id}`;
  return (dispatch) => {
    patchRequest(
      url,
      {
        isactive: isactive,
        eventid: session.eventid,
      },
      session,
      dispatch,
      (response) => {
        callback({ success: 1, response: response });
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
}

/***** Get Static content Template HTML *****/
export function getStaticTemplteHtml(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/gamification_admin_script`;

  return (dispatch) => {
    postRequest(
      url,
      {
        requesttype: "getStaticTemplteHtml",
      },
      session,
      dispatch,
      (response) => {
        var string = _.replace(
          response.resource.data,
          new RegExp("{base_url}", "g"),
          `${BASE_IMAGES_LOCAL_URL}/eventify/gamification/certificatehtml`
        );
        // Using the _.replace() global method
        let replace_elem = _.replace(string);

        dispatch({
          type: MANAGECHALLENGES_HTML_TEMPLATE,
          payload: { data: replace_elem },
        });
        callback({ status: 1 });
      },
      (error) => {}
    );
  };
}

/*****  Load Edit challenges *****/
export function loadEditchallengesData(challenges, staticTemplteHtml) {
  // get static content First

  if (challenges["rewardtype"] == "award") {
    // If Reward Type is "award"
    if (
      challenges["award"] != "" &&
      challenges["award"] != "null" &&
      challenges["award"] != null
    ) {
      // Image is there so select default option "Upload Image"
      challenges = { ...challenges, ["option"]: "upload" };
    } else {
      challenges = { ...challenges, ["option"]: "html" };
    }
  }
  challenges = { ...challenges, [challenges.id]: challenges.displayorder };

  if (challenges.award_template) {
    // Original array

    var string = _.replace(
      challenges.award_template,
      new RegExp("{base_url}", "g"),
      `${BASE_IMAGES_URL}/eventify/gamification/certificatehtml`
    );
    // Using the _.replace() global method
    let replace_elem = _.replace(string);

    // Printing the output
    challenges["award_template"] = replace_elem;
  } else {
    challenges["award_template"] = staticTemplteHtml;
  }

  return {
    type: LOAD_EDIT_CHALLENGES_DATA,
    payload: challenges,
  };
}

// Open Modal
export function openChallengesModal(option) {
  return {
    type: OPEN_CHALLENGES_MODAL,
    payload: option,
  };
}

// Insert And edit Challenges
export function insertChallenge(session, values, challenge, callback) {
  // var eventid = session.eventid;
  var eventid = session.eventid;
  if (values.rewardtype == "award") {
    if (values.hasOwnProperty("option")) {
      if (values.option == "upload") {
        values["award_template"] = "";
      } else {
        values["award"] = "";
      }
    }
  }

  if (values.hasOwnProperty("award_template")) {
    if (
      values.award_template != "" &&
      values.award_template != null &&
      values.award_template != "null"
    ) {
      // Change The base URL for award_template
      // var string = _.replace(values.award_template, `${BASE_IMAGES_LOCAL_URL}/eventify/gamification/certificatehtml`,'{base_url}');
      var string = _.replace(
        values.award_template,
        new RegExp(
          `${BASE_IMAGES_URL}/eventify/gamification/certificatehtml`,
          "g"
        ),
        "{base_url}"
      );
      // Using the _.replace() method
      let replace_elem = _.replace(string);

      // Printing the output
      values["award_template"] = replace_elem;
    }
  }

  var imagedata = values.award ? values.award : "";

  var url, challengeJson;

  if (isEmpty(challenge)) {
    url = `${INSTANCE_URL}/api/v2/eventify/_table/gamification_challenge`;
    challengeJson = { resource: values };
  } else {
    var id = values.id;
    url = `${INSTANCE_URL}/api/v2/eventify/_table/gamification_challenge?filter=id=${id}`;
  }

  if (imagedata.search(";base64,") > 0) {
    imagedata = imagedata.replace(/^data:image\/[a-z]+;base64,/, "");
    var filename = `eventify/${eventid}/gamification/image/${randomstring(
      32
    )}.jpg`;
    var imageJson = {
      resource: [
        {
          name: filename,
          type: "file",
          is_base64: true,
          content: imagedata,
        },
      ],
    };

    return (dispatch) => {
      uploadEncodedFile(
        `${BASE_IMAGES_URL}?check_exist=false`,
        session,
        imageJson,
        dispatch,
        (data) => {
          values = { ...values, award: data.path };
          var removeKeyName = values.id;
          values = _.omit(values, [removeKeyName]);
          challengeJson = { resource: values };
          // image is uploaded and filepath is appended
          // dispatch(

          // );
          var successCallback = (data) => {
            callback({ error: 0, data: data });
          };

          var errorCallback = (error) => {
            callback({ error: 1, data: error });
          };

          if (isEmpty(challenge)) {
            postRequest(
              url,
              challengeJson,
              session,
              dispatch,
              successCallback,
              errorCallback
            );
          } else {
            patchRequest(
              url,
              challengeJson,
              session,
              dispatch,
              successCallback,
              errorCallback
            );
          }
        },
        (error) => {
          callback({ error: 2, data: error });
        }
      );
    };
  } else {
    var removeKeyName = values.id;

    values = _.omit(values, [removeKeyName]);

    challengeJson = { resource: values };

    return (dispatch) => {
      var successCallback = (data) => {
        callback({ error: 0, data: data });
      };

      var errorCallback = (error) => {
        callback({ error: 1, data: error });
      };

      if (isEmpty(challenge)) {
        postRequest(
          url,
          challengeJson,
          session,
          dispatch,
          successCallback,
          errorCallback
        );
      } else {
        patchRequest(
          url,
          challengeJson,
          session,
          dispatch,
          successCallback,
          errorCallback
        );
      }
    };
  }
}

export function updateChallengeList(
  session,
  callfor,
  newArrAvailable,
  callback
) {
  var url = `${INSTANCE_URL}/api/v2/gamification_admin_script`;

  return (dispatch) => {
    if (callfor == MANAGECHALLENGES_SINGE_LIST) {
      dispatch({
        type: MANAGECHALLENGES_SINGE_LIST,
        payload: { data: newArrAvailable, count: newArrAvailable.length },
      });
    } else {
      dispatch({
        type: MANAGECHALLENGES_RECURRING_LIST,
        payload: { data: newArrAvailable, count: newArrAvailable.length },
      });
    }

    postRequest(
      url,
      {
        requesttype: "updatechallenge",
        eventid: session.eventid,
        newArrAvailable: newArrAvailable,
      },
      session,
      dispatch,
      (response) => {
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}
